import { combineReducers } from 'redux'
import { resettableReducer } from 'reduxsauce'
import { NotificationsManagerReducer } from 'advenio-components'
import { AuthRedux } from 'auth-advenio'
import configureStore from './CreateStore'
import epicMiddleware from '../Observables'

const resettable = resettableReducer('RESET')

export default (middlewares) => {
    /* ------------- Assemble The Reducers ------------- */
    const rootReducer = combineReducers({
        activeCheckins: require('./ActiveCheckinsRedux').reducer,
        activity: require('./ActivityRedux').reducer,
        addSibling: require('./AddSiblingRedux').reducer,
        advanced_search: require('./AdvancedSearchRedux').reducer,
        allCenters: require('./AllCentersRedux').reducer,
        assistance: require('./AssistanceRedux').reducer,
        attendance: require('./AttendanceRedux').reducer,
        auth: AuthRedux.reducer,
        averageAttendance: require('./AverageAttendanceRedux').reducer,
        balance: require('./BalanceRedux').reducer,
        cards: require('./CardsRedux').reducer,
        centerClassroom: require('./CenterClassroomRedux').reducer,
        centerOptions: require('./CenterOptionsRedux').reducer,
        centerVisitAverage: require('./CenterVisitAverageRedux').reducer,
        center_products: require('./CenterProductsRedux').reducer,
        centers: require('./CenterRedux').reducer,
        centersExcel: require('./CentersExcelRedux').reducer,
        centersInfo: require('./CentersInfoRedux').reducer,
        checkin_inventory: require('./CheckinInventoryRedux').reducer,
        checkins: require('./CheckinsRedux').reducer,
        classrooms: require('./ClassroomRedux').reducer,
        companies: require('./CompaniesRedux').reducer,
        consumables: require('./ConsumablesRedux').reducer,
        consumables_categories: require('./ConsumablesCategoriesRedux').reducer,
        contracts: require('./ContractsRedux').reducer,
        countries: require('./CountriesRedux').reducer,
        courses: require('./CoursesRedux').reducer,
        dailyAttendance: require('./DailyAttendanceRedux').reducer,
        demographics: require('./DemographicsRedux').reducer,
        domiciliationReport: require('./DomiciliationReportRedux').reducer,
        disenrollment: require('./DisenrollmentCategoriesRedux').reducer,
        disenrollmentreport: require('./DisenrollmentReportRedux').reducer,
        disenrollments: require('./DisenrollmentsRedux').reducer,
        documents: require('./DocumentsRedux').reducer,
        emergencyMedications: require('./EmergencyMedications').reducer,
        enroll: require('./EnrollRedux').reducer,
        enrollmentreport: require('./EnrollmentReportRedux').reducer,
        enrollmentsCategories: require('./EnrollmentsCategoriesRedux').reducer,
        evaluation: require('./EvaluationRedux').reducer,
        finances: require('./FinancesRedux').reducer,

        healthCheck: require('./HealthCheckRedux').reducer,
        healthTeacher: require('./HealthTeacherRedux').reducer,
        historical: require('./HistoricalRedux').reducer,
        home_report: require('./ParentPlatform/HomeReportRedux').reducer,
        incident: require('./IncidentRedux').reducer,
        incidentTypes: require('./IncidentTypes').reducer,
        inscriptions: require('./InscriptionsRedux').reducer,
        inventory: require('./InventoryRedux').reducer,
        masterlistreport: require('./MasterListReportRedux').reducer,
        medallia: require('./MedalliaRedux').reducer,
        medicines_center: require('./MedicinesCenterRedux').reducer,
        mood: require('./Mood').reducer,
        motives: require('./MotivesRedux').reducer,
        net: require('./NetRedux').reducer,
        notifications: NotificationsManagerReducer,
        notifications_types: require('./NotificationsRedux').reducer,
        overview: require('./OverviewRedux').reducer,
        parent_payment_types: require('./ParentPaymentTypesRedux').reducer,
        parent_platform_balance: require('./ParentPlatform/BalanceRedux').reducer,
        parent_platform_children: require('./ParentPlatform/ChildrenRedux').reducer,
        parent_platform_medicine: require('./ParentPlatform/MedicineRedux').reducer,
        parent_platform_payments: require('./ParentPlatform/PaymentsRedux').reducer,
        parent_platform_rating: require('./ParentPlatform/RatingRedux').reducer,
        parent_platform_reservation: require('./ParentPlatform/ReservationRedux').reducer,
        payment_reminders: require('./PaymentRemindersRedux').reducer,
        payment_types: require('./PaymentTypesRedux').reducer,
        payment_types_msi: require('./PaymentTypesMsiRedux').reducer,
        programLevels: require('./ProgramLevelsRedux').reducer,
        ratings: require('./RatingsRedux').reducer,
        receiptreport: require('./ReceiptReportRedux').reducer,
        reEnroll: require('./ReEnrollRedux').reducer,
        reEnrollFromDisenrollments: require('./ReEnrollFromDisenrollmentsRedux').reducer,
        re_enrollments: require('./ReEnrollmentsRedux').reducer,
        regimen_fiscal: require('./RegimenFiscalRedux').reducer,
        relations: require('./RelationsRedux').reducer,
        reservationBmx: require('./ReservationBmxRedux').reducer,
        reserved: require('./ReservedRedux').reducer,
        reserved_enrollments: require('./ReservedEnrollmentsRedux').reducer,
        resetPassword: require('./ResetPasswordRedux').reducer,
        serviceOccasional: require('./ServiceOccasionalRedux').reducer,
        service_types: require('./ServiceTypesRedux').reducer,
        studentCheckin: require('./StudentCheckinRedux').reducer,
        student_photos: require('./ParentPlatform/PhotosRedux').reducer,
        study_programs: require('./StudyProgramsRedux').reducer,
        teacherDistribution: require('./TeacherDistributionRedux').reducer,
        totalAttendance: require('./TotalAttendanceRedux').reducer,
        unitKeys: require('./UnitKeysRedux').reducer,
        unvalidatedPhotos: require('./UnvalidatedPhotosRedux').reducer,
        unvalidatedReceipts: require('./UnvalidatedReceiptsRedux').reducer,
        uso_cfdi: require('./UsoCFDIRedux').reducer,
        users: require('./UsersRedux').reducer,
        validatedReceipts: require('./ValidatedReceiptsRedux').reducer,
        visitAverageAttendance: require('./VisitAverageAttendanceRedux').reducer,

    })

    return configureStore(resettable(rootReducer), [epicMiddleware, ...middlewares])
}



// WEBPACK FOOTER //
// ./src/Data/Redux/index.js